var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator"},[(_vm.isOnline)?_c('div',{staticClass:"online"},[_vm._v("ONLINE")]):_c('div',{staticClass:"offline"},[_vm._v("ONLINE")])])}
var staticRenderFns = []

export { render, staticRenderFns }